import {Component, forwardRef, Input} from "@angular/core";
import {
    AbstractSearchControlComponent,
    registerSearchControl
} from "../../../entity/search/search-controls/abstract-search-control.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NumericSearchControlComponent),
    multi: true
};

@Component({
    selector: "wbo-numeric-search-control",
    templateUrl: "./numeric-search-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR,
        registerSearchControl(NumericSearchControlComponent)
    ]
})
export class NumericSearchControlComponent extends AbstractSearchControlComponent {
    @Input() decimals: number;
    @Input() showClear: boolean = false;
}
